<template>
<div >
	<Loader :show="loading"></Loader>
	<b-modal id="modalDelivery" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
		
		<div class="fullscreen" v-if="show">
			<div class="head xl" :class="{
					'head-warning':type=='warning',
					'head-success':type=='success',
				}">
				<div class="container">
					<i class="icon mt-4 icon-xl invert icon-warning" v-if="type=='warning'"></i>
					<i class="icon mt-4 icon-xl invert icon-check" v-if="type=='success'"></i>
					<h1>{{title}}</h1>
					<p>Ingrese los datos de quién entrega el vehículo</p>
				</div>
			</div>
			<div class="content bg-grey">
				<div class="container">
					
					<b-form-group label="Matrícula del camión" class="mt-4">
						<b-form-input
							v-model="form.truck_mat"
							placeholder="Ingrese la matrícula del camión"
							:state="!validation.hasError('form.truck_mat')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese la matrícula del camión</b-form-invalid-feedback>
					</b-form-group>

					<b-form-group label="Nombre completo del conductor" class="mt-4">
						<b-form-input
							v-model="form.truck_driver_name"
							placeholder="Ingrese el nombre"
							:state="!validation.hasError('form.truck_driver_name')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese el nombre completo del conductor</b-form-invalid-feedback>
					</b-form-group>
					
					<b-form-group label="Firma" class="mt-4 mb-4">
						<!-- <div class="invalid-feedback d-block" v-if="validation.hasError('form.signature')">Ingrese la firma del conductor</div>					 -->
						<SignatureInput v-model="form.signature"></SignatureInput>
					</b-form-group>

				</div>
			</div>
			<div class="footer">
				<div class="container">
					<div class="btn btn-block btn-primary" @click="save()">
						Continuar
					</div>
				</div>
			</div>
		</div>

	</b-modal>	
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Loader from '@/components/Loader'
import SignatureInput from '@/components/SignatureInput'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'DeliveryForm',
	components:{
		Loader,
		SignatureInput
	},
	props:{
		title: {
			type: String,
			default: 'Se han detectado daños y/o faltantes'
		},
		type: {
			type: String,
			default: 'warning'
		},
	},
	data () {
		return {
			show: false,
			loading:false,
			saving: false,
			form:{
				truck_mat: null,
				truck_driver_name:null,
				signature: null,
			},
		}
	},
	computed: {
		...mapState(['control']),
	},
	validators: {
		'form.truck_mat': function (value) {
			return Validator.value(value).required();
		},
		'form.truck_driver_name': function (value) {
			return Validator.value(value).required();
		},
		// 'form.signature': function () {
		// 	return Validator.custom( () => {
		// 		return this.$refs.signature.isEmpty()
		// 	})
		// },
	},
	mounted(){
		this.open()
	},
	methods: {
		...mapMutations(['saveControl']),
		checkValidation() {
			return this.$validate()
			.then(function (success) {
				if (success) {
					return true
				}
				return false
			});
		},
		open () {
			this.show = true
			this.$bvModal.show('modalDelivery')
		},
		close () {
			this.$bvModal.hide('modalDelivery')
			this.form = {
				truck_mat: null,
				truck_driver_name:null,
			}
			this.saving = false
		},
		
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				this.control.delivered_by_mat = this.form.truck_mat
				this.control.delivered_by_driver_name = this.form.truck_driver_name
				this.control.delivered_by_driver_signature = this.form.signature
				this.saveControl(this.control)
				this.close()
				this.$emit('done')
			}
		}
	}
}


</script>

<style lang="scss" scoped>
	
</style>